import { useEffect, useState } from 'react';

import { useAmbassadorService } from '@restworld/data-services';
import { Ambassador } from '@restworld/utility-types';
import { useAuth } from '@restworld/feature-authentication';

export const useAmbassadorData = () => {
  const [ambassadorData, setAmbassadorData] = useState<Ambassador>();
  const ambassadorService = useAmbassadorService();
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    const callApi = async () => {
      // `ambassador?` (from /me and from login), not `user.type`: somebody who
      // is both a worker and an ambassador keeps type "worker" so they can
      // still apply to job positions, and gating on the type left exactly
      // those people without their ambassador code.
      if (!user?.['ambassador?']) return;
      try {
        const meResponse = await ambassadorService.me();
        setAmbassadorData(meResponse.data);
      } catch (error) {
        console.error(error, 'error fetching ambassador data');
      }
    };
    if (isAuthenticated) callApi();
  }, [ambassadorService, isAuthenticated, user?.['ambassador?']]);
  return ambassadorData;
};
